import { Command } from 'commands/Commands';

export class AddPartnerToBusiness extends Command {
  type: string = 'Partner.AddToBusiness';
  constructor(payload: string, id: string = payload) {
    super(payload, id);
  }
  priority: number = 100;
}
